import React from 'react';
import { SvgWithSizeProps } from '../interfaces';

const SVGCarouselArrow = ({
  color,
  size = 20,
  className
}: SvgWithSizeProps) => {
  return (
    <svg
      width={size}
      height={size * 1.2}
      viewBox='0 0 20 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path d='M20 12L0.500001 23.2583L0.500002 0.741669L20 12Z' fill={color} />
    </svg>
  );
};

export default SVGCarouselArrow;
